import React from 'react';

const InvitationIntro = () => {
  return (
    <div className="flex flex-col">
      <div
        className="w-[23.4375rem] h-[44.8125rem] bg-full bg-no-repeat"
        style={{
          backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-1.webp')})`,
        }}
      />
      <div
        className="w-[23.4375rem] h-[75rem] bg-full bg-no-repeat"
        style={{
          backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-2.webp')})`,
        }}
      />
      <div
        className="w-[23.4375rem] h-[64.3125rem] bg-full bg-no-repeat"
        style={{
          backgroundImage: `url(${require('@/assets/imgs/invitation/invite-pic-3.webp')})`,
        }}
      />
    </div>
  );
};

export default InvitationIntro;
